import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../../forms/FormMixin'
import { useRoute } from 'vue-router'
import { storage } from '@/utils/session'
import { useUserStore } from '@/stores/user'
import {
  emailChangeResource,
} from '@/services/profile.service'
  
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailChengeModal',
  props: ['idCrypt', 'userToken'],
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const store = useUserStore()

const storeRefresher = computed(() => useUserStore())

const props = __props

const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 
const dataIsSended = ref(false)
const nonFieldErrors = ref("")
const password = ref(null)
const email = ref(null)

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const send = async (sendData: any, control: any) => {
  try {
      load.value = true
      const { redirectLink } = (await emailChangeResource.execute({}, {
        ...sendData,
      }))
      dataIsSended.value = true
      load.value = false
      storeRefresher.value.getUserData()
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}
  
const __returned__ = { store, storeRefresher, props, emit, $t, load, dataIsSended, nonFieldErrors, password, email, request, send, ref, computed, get useSubmit() { return useSubmit }, get useRoute() { return useRoute }, get storage() { return storage }, get useUserStore() { return useUserStore }, get emailChangeResource() { return emailChangeResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})